import { Segment } from 'client/Global/Segment'
import { SegmentEvents } from 'client/Global/SegmentEvents'
import { StateInterface } from 'client/Interfaces/StateInterface'
import { connect } from 'client/utils'
import * as React from 'react'

import { Datadog } from '../Global/Datadog'
import './ErrorBoundary.scss'
import Oops from './Oops'

interface IStateProps {
  hasError: boolean
}

interface IExternalProps {
  randomBucket: number
  country: string
}

class ErrorBoundary extends React.Component<
  { path: string; children: JSX.Element; language: string } & IExternalProps,
  IStateProps
> {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error) {
    this.setState({ hasError: true })
    try {
      const oopsError = new Error(`Oops page: ${error.message}`)
      oopsError.stack = error.stack

      Datadog.addError(oopsError, {
        component: 'ErrorBoundary',
      })

      Segment.track(SegmentEvents.debug.oopsScreen, {
        random_bucket: this.props.randomBucket,
        context: window.location?.pathname,
        window_absolute_url: window.location?.href,
        country: this.props.country,
        error_message: error?.message,
      })
    } catch (error) {}
  }

  componentDidUpdate(prevProps) {
    if (this.props.path !== prevProps.path) {
      this.setState({ hasError: false })
    }
  }

  public render() {
    if (this.state.hasError) {
      return <Oops language={this.props.language} />
    }
    return this.props.children
  }
}

const mapStateToProps = (state: StateInterface) => ({
  randomBucket: state.company?.randomBucket,
  country: state.company?.country,
})

export default connect(mapStateToProps, null)(ErrorBoundary)
